import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

export const skipGlobalLoader = (): HttpContext =>
  new HttpContext().set(SKIP_GLOBAL_LOADER, true);
